export default __webpack_public_path__ + "static/media/2.cad96f90.jpg";